import { patientActions, noteActions, cdvActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
    supervisors: []
};

export const reducer = createReducer(initialState, {

    [patientActions.loadSuccess]: (state, action) => {
        var patients = {};

        Object.values(action.payload.entities.patients).forEach(x => {
            patients[x.id] = {
                id: x.id,
                addendumVisible: false,
                addendumDoc: undefined,
                scribeVisible: false,
                scribeDoc: undefined,
                clinicalDocsVisible: true,
                fotoDocsVisible: true,
                chargeAddendumQuestionVisible: false,
                chargeAddendumQuestionDoc: undefined,
                chargeAddendumVisible: false,
                chargeAddendumDoc: undefined
            };
        });
        state = { ...state, ...patients };

        return state;
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        var cdvOptions = { ...action.payload.ui.cdvOptions };

        Object.keys(cdvOptions).forEach(key => {
            var entry = cdvOptions[key];
            // skip non-patient entries (e.g. supervisors array)
            if (entry && !Array.isArray(entry) && entry.id !== undefined) {
                cdvOptions[key] = {
                    ...entry,
                    chargeAddendumVisible: false,
                    chargeAddendumQuestionVisible: false,
                    chargeAddendumDoc: undefined,
                    chargeAddendumQuestionDoc: undefined

                };
            }
        });

        return { ...state, ...cdvOptions };
    },
    [patientActions.closeSuccess]: (state, action) => {
        delete state[action.payload];
    },
    [patientActions.loadSupervisiorsSuccess]: (state, action) => {
        state.supervisors = action.payload.supervisors;
    },
    [noteActions.showAddendum]: (state, action) => {
        state[action.payload.ptno].addendumVisible = true;
        state[action.payload.ptno].addendumDoc = action.payload.noteId;
    },
    [noteActions.hideAddendum]: (state, action) => {
        state[action.payload.ptno].addendumVisible = false;
        state[action.payload.ptno].addendumDoc = undefined;
    },
    [noteActions.showScribe]: (state, action) => {
        state[action.payload.ptno].scribeVisible = true;
        state[action.payload.ptno].scribeDoc = action.payload.noteId;
    },
    [noteActions.hideScribe]: (state, action) => {
        state[action.payload.ptno].scribeVisible = false;
        state[action.payload.ptno].scribeDoc = undefined;
    },
    [noteActions.saveAddendumSuccess]: (state, action) => {
        state[action.payload].addendumVisible = false;
        state[action.payload].addendumDoc = undefined;
    },
    [cdvActions.toggleClinicalDocsVisibility]: (state, action) => {
        state[action.payload].clinicalDocsVisible = !state[action.payload].clinicalDocsVisible
    },
    [cdvActions.toggleFotoDocsVisibility]: (state, action) => {
        state[action.payload].fotoDocsVisible = !state[action.payload].fotoDocsVisible
    },
    [noteActions.showChargeAddendumQuestion]: (state, action) => {
        state[action.payload.ptno].chargeAddendumQuestionVisible = true;
        state[action.payload.ptno].chargeAddendumQuestionDoc = action.payload.noteId;
    },
    [noteActions.hideChargeAddendumQuestion]: (state, action) => {
        state[action.payload.ptno].chargeAddendumQuestionVisible = false;
        state[action.payload.ptno].chargeAddendumQuestionDoc = undefined;
    },
    [noteActions.showChargeAddendum]: (state, action) => {
        state[action.payload.ptno].chargeAddendumVisible = true;
        state[action.payload.ptno].chargeAddendumDoc = action.payload.noteId;
    },
    [noteActions.hideChargeAddendum]: (state, action) => {
        state[action.payload.ptno].chargeAddendumVisible = false;
        state[action.payload.ptno].chargeAddendumDoc = undefined;
    }

})


